import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/01_atoms/Button';
import Link from '../../Link';
import { propTypes as linkPropTypes } from '../../../components/01_atoms/Link';

import styles from './index.module.scss';

/**
 * TODO: Update the component if needed and add styles.
 */
const BBButton = ({ link = null, buttonPosition = 'center', buttonType = 'primary' }) => (
  <div
    className={`bb bb-button container ${styles['bb-button']} ${styles[`bb-button--${buttonPosition}`]}`}
  >
    <Link {...link.nextLink}>
      <Button type={buttonType}>{link.label}</Button>
    </Link>
  </div>
);

BBButton.propTypes = {
  link: PropTypes.shape({
    label: PropTypes.string,
    nextLink: PropTypes.shape(linkPropTypes),
  }),
  buttonPosition: PropTypes.oneOf(['left', 'center']),
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
};

export default BBButton;
